document.addEventListener('DOMContentLoaded', function () {
    const countdown = document.querySelector('.countdown-timer');
    const targetDate = new Date(countdown.dataset.targetDate);

    function updateCountdown() {
        const now = new Date();
        const timeDiff = targetDate - now;

        if (timeDiff <= 0) {
            countdown.innerHTML = "Time's up!";
            return;
        }

        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        countdown.querySelector('.countdown-days').textContent = days.toString().padStart(2, '0');
        countdown.querySelector('.countdown-hours').textContent = hours.toString().padStart(2, '0');
        countdown.querySelector('.countdown-minutes').textContent = minutes.toString().padStart(2, '0');
        countdown.querySelector('.countdown-seconds').textContent = seconds.toString().padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
});